type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    textarea?: boolean;
    error?: string;
  };

export const Input = ({ className, textarea, error, ...props }: InputProps) => {
  const errorClasses = error ? "border border-red-500" : "";

  return (
    <div className="flex flex-col gap-1 items-end">
      {!textarea ? (
        <input
          className={`bg-white-transparent sm:rounded-xl text-main-mobile sm:text-main rounded-lg w-full sm:placeholder:text-main placeholder:text-main-mobile focus:bg-white-main/30 hover:bg-white-main/25 placeholder:text-gray-main focus:outline-none sm:px-6 px-[18px] sm:py-4 py-3.5 transition-all ${className} ${errorClasses}`}
          {...props}
        />
      ) : (
        <textarea
          className={`bg-white-transparent sm:rounded-xl text-main-mobile sm:text-main rounded-lg w-full resize-none sm:placeholder:text-main placeholder:text-main-mobile focus:bg-white-main/30 hover:bg-white-main/25  placeholder:text-gray-main focus:outline-none sm:px-6 px-[18px] sm:py-4 py-3.5 transition-all ${className} ${errorClasses}`}
          {...props}
        />
      )}
      {error && (
        <span className="text-red-500 text-sm sm:text-base">{error}</span>
      )}
    </div>
  );
};
